<template>
  <b-tab-item label="PRICING">
    <div class="table-layout-auto tableEditPricing EditServiceSideBarBox mb-6">
      <div class="b-table">
        <div class="table-wrapper has-mobile-cards">
          <table class="table">
            <tbody class="is-block">
              <tr
                v-if="helpers.hasViewCostPricePermission(authData)"
                class="is-flex is-justify-content-center is-align-items-center py-1"
              >
                <td>Cost Unit</td>
                <td class="color-7">
                  {{ getCostCurrency(formItineraryService) }}
                  {{
                    formItineraryService.cost_unit ||
                    formItineraryService.cost ||
                    0
                  }}
                </td>
              </tr>

              <tr
                class="is-flex is-justify-content-center is-align-items-center py-1"
              >
                <td>Provider</td>
                <td>
                  {{ serviceSuppliers }}
                </td>
              </tr>

              <tr
                class="is-flex is-justify-content-center is-align-items-center py-1"
              >
                <td>
                  {{
                    helpers.getComplementTextByServiceType(
                      service.id_service_type
                    )
                  }}
                </td>
                <td>
                  {{ formItineraryService.days }}
                </td>
              </tr>

              <tr
                v-if="hasViewSalesManualPermission"
                class="is-flex is-justify-content-center"
              >
                <td class="has-text-centered">Sales Manual</td>
                <td class="color-7">
                  {{ getServiceSalesManualCode() }}
                </td>
              </tr>

              <tr v-if="helpers.hasViewCostPricePermission(authData)">
                <td class="has-text-centered">Cost</td>
                <td class="color-7">
                  {{ getCostCurrency(formItineraryService) }}
                  {{ formItineraryService.cost || 0 }}
                </td>
              </tr>
              <tr
                class="is-flex is-justify-content-center is-align-items-center py-1"
              >
                <td>
                  {{
                    helpers.isAccommodationPackageService(
                      formItineraryService.id_service_type
                    )
                      ? "Price P. Night"
                      : "Sales Price / Unit"
                  }}
                </td>
                <td class="color-7">
                  {{ getSalesPriceCurrency(formItineraryService) }}
                  {{ formItineraryService.price_unit || "0.00" }}
                </td>
              </tr>
              <tr
                class="is-flex is-justify-content-center is-align-items-center pt-1 is-relative"
              >
                <td class="has-text-centered">Total Price (*)</td>
                <td
                  v-if="
                    hasViewSalePricePermission &&
                    hasNewPriceAvailable &&
                    !disableQuoteByStatus
                  "
                >
                  <AlertButton
                    v-if="hasViewSalePricePermission && hasNewPriceAvailable"
                    :label="
                      'Price is outdated. Click to use new price: ' +
                      getSalesPriceCurrency(formItineraryService) +
                      originalServicePrice
                    "
                    :text="
                      getSalesPriceCurrency(formItineraryService) +
                      originalServicePrice
                    "
                    :onButtonClick="updateServicePrice"
                  />
                </td>
                <td
                  class="color-7 edit_service_sidebar__total_price"
                  style="width: 60%"
                >
                  <div
                    class="is-flex is-justify-content-center is-align-items-center"
                    style="height: 2rem; gap: 0.5rem"
                    :data-test-id="
                      constants.DATA_TEST_ID_VALUES
                        .ITINERARY_SERVICE_SIDEBAR_PRICE
                    "
                  >
                    <BaseInput
                      v-if="
                        hasEditSalePricePermission &&
                        !hideElementByCondition &&
                        !disableQuoteByStatus &&
                        !isServiceDatesRangeEdited
                      "
                      @input="emitUpdateForm('price', $event)"
                      :value="formItineraryService.price"
                      size="large"
                      type="number"
                    />
                    <span v-else>{{
                      formItineraryService.price || "0.00"
                    }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="color-2 font-weight-500 mt-4">
            (*) Subtotal and Total price are rounded: &lt; 0.5 down, &ge; 0.5
            up.
          </p>
        </div>
      </div>
    </div>

    <div v-if="hasNotServicePrice" class="no_price_alert__container">
      <div>
        <IconInfo />

        <p class="ml-2" style="display: inline-block">
          <strong>There are not prices for this service</strong>, please try
          updating the service using the option:
        </p>

        <BaseButton @click="importQuoteService" action="principal" class="ml-2">
          <i slot="icon" class="ml-1">
            <b-icon
              size="is-small"
              custom-size="mdi-18px"
              icon="swap-vertical-bold"
              class="mr-1"
            ></b-icon>
          </i>
          <p slot="text">Import Service</p>
        </BaseButton>
      </div>

      <p class="my-2">
        Be aware the service requiere to be included in the Sales Manual for the
        dates from {{ formItineraryService.start_date }} to
        {{ formItineraryService.end_date }} if this a accommodation or package
        you would need to also considerate the Room Type Single, Double, Triple,
        Etc. this is requirement to confirm the itinerary, you would be able to
        change the status to Sent but not Confirm it.
      </p>

      <p>if the problem persist, contact us at support@itereo.travel</p>
    </div>
  </b-tab-item>
</template>

<script>
import { mapGetters } from "vuex";
import helpers from "@/helpers";
import { serviceHelper } from "@/utils/service";
import { USER_ROLE, SERVICE_TYPE, PERMISSION } from "@/constants";
import { DATA_TEST_ID_VALUES } from "@/constants/test";
import AlertButton from "@/components/_shared/AlertButton.vue";
import { ROOM_FIELDS } from "@/constants/services";
import { calculateDays } from "@/utils/utils";

export default {
  name: "EditServiceSideBarTabsPricing",
  components: {
    AlertButton,
  },
  data() {
    return {
      constants: {
        DATA_TEST_ID_VALUES,
      },
      helpers: { ...helpers, ...serviceHelper },
    };
  },
  props: {
    isServiceDatesRangeEdited: {
      type: Boolean,
      default: false,
    },
    itineraryService: {
      type: Object,
      default: () => {},
    },
    formItineraryService: {
      type: Object,
      default: () => {},
    },
    automaticPriceCalculate: {
      type: Boolean,
      default: true,
    },
    serviceFirstTime: {
      type: Boolean,
      default: false,
    },
    originalServicePrice: {
      type: Number,
      default: 0,
    },
    hasNotServicePrice: {
      type: Boolean,
      default: false,
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
    importService: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    async importQuoteService() {
      this.setLoading(true);
      await this.importService(this.itineraryService);
      this.setLoading(false);
    },
    getServiceSalesManualCode() {
      return (
        this.itineraryService?.service_price?.[0]?.sales_manual_code || "-"
      );
    },
    async updateServicePrice() {
      if (
        !serviceHelper.isAccommodationPackageService(
          this.formItineraryService.id_service_type
        )
      ) {
        await this.emitUpdateForm(
          "prices_costs_margins",
          this.formItineraryService?.prices_costs_margins
        );
      } else {
        const nights =
          this.formItineraryService.id_service_type !== SERVICE_TYPE.PACKAGE
            ? calculateDays(
                this.formItineraryService.start_date,
                this.formItineraryService.end_date
              ) - 1
            : 1;
        const newRooms = serviceHelper.updateRoomPrices(
          this.formItineraryService.room,
          ROOM_FIELDS.NEW_PRICE_UNIT,
          null,
          nights
        );
        await this.emitUpdateForm("rooms_price", newRooms);
      }

      await this.emitUpdateForm("saveService", true);
    },
    getItineraryCurrencyCode() {
      const currency_code = this.itinerary?.data?.currency?.currency_code || "";
      return currency_code;
    },
    getItineraryCurrencySign() {
      const currency_sign = this.itinerary?.data?.currency?.currency_sign || "";
      return currency_sign;
    },
    getSalesPriceCurrency(formItineraryService) {
      if (formItineraryService.service_price === null)
        return `${this.getItineraryCurrencyCode()} ${this.getItineraryCurrencySign()}`;
      if (formItineraryService.service_price === undefined)
        return `${this.getItineraryCurrencyCode()} ${this.getItineraryCurrencySign()}`;
      const currency_sign =
        formItineraryService?.service_price[0]?.currency_sign ??
        this.getItineraryCurrencySign();
      const currency_code =
        formItineraryService?.service_price[0]?.currency_code ??
        this.getItineraryCurrencyCode();
      return `${currency_code} ${currency_sign}`;
    },
    getCostCurrency(formItineraryService) {
      if (formItineraryService.service_supplier === null)
        return `${this.getItineraryCurrencyCode()} ${this.getItineraryCurrencySign()}`;
      if (formItineraryService.service_supplier === undefined)
        return `${this.getItineraryCurrencyCode()} ${this.getItineraryCurrencySign()}`;
      const currency_sign =
        formItineraryService?.service_supplier[0]?.currency_sign ??
        this.getItineraryCurrencySign();
      const currency_code =
        formItineraryService?.service_supplier[0]?.currency_code ??
        this.getItineraryCurrencyCode();
      return `${currency_code} ${currency_sign}`;
    },
    emitUpdateForm(key, value) {
      this.$emit("update", [key, value]);
    },
  },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
      service: "services/getService",
      user: "auth/getAuthUserData",
      authData: "auth/getAuthData",
      disableQuoteByStatus: "itinerary/getDisableQuoteByStatus",
      hideElementByCondition: "itinerary/getHideElementByCondition",
    }),
    hasViewSalePricePermission() {
      return serviceHelper.hasAnyViewPermissions(
        this.authData,
        this.itinerary,
        [PERMISSION.VIEW_SALE_PRICE, PERMISSION.VIEW_PRICE_SEARCHED]
      );
    },
    hasNewPriceAvailable() {
      return (
        this.originalServicePrice !== this.formItineraryService?.price &&
        ![null, 0].includes(this.originalServicePrice)
      );
    },
    serviceSuppliers() {
      const isAdmin = helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.ADMIN],
        true
      );
      return isAdmin
        ? serviceHelper.getServiceSuppliers(this.formItineraryService)
        : "";
    },
    hasEditSalePricePermission() {
      return !helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.TRAVEL_AGENT],
        false
      );
    },
    hasViewSalesManualPermission() {
      return helpers.hasAnyRoles(this.authData.user, [USER_ROLE.ADMIN], true);
    },
  },
};
</script>

<style scoped>
.sidebar_import_service__button {
  font-size: 0.8rem;
  float: right;
  margin-bottom: 0.5rem;
  /* position: absolute;
  top: 1rem;
  right: 1rem; */
}

.no_price_alert__container {
  background-color: #ff00005d;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.no_price_alert__container svg {
  width: 1rem;
}

.no_price_alert__container .field {
  display: inline-block;
}

@media screen and (max-width: 480px) {
  .tableEditPricing {
    width: 100%;
  }
  .tableEditPricing .b-table .table-wrapper.has-mobile-cards tr {
    box-shadow: none;
  }
  .edit_service_sidebar__total_price {
    width: 25% !important;
  }
}
</style>
